import { initials } from '../../lib/constants';

export function Avatar({ nome, src, size = '' }) {
  const cls = `avatar ${size}`;
  if (src) return <div className={cls}><img src={src} alt={nome || ''} /></div>;
  return <div className={cls}>{initials(nome)}</div>;
}
